import React, { useMemo, useState, useEffect } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import { toast } from "../components/Toast";

export default function StockSettings({ inventory, houseId, onClose }) {
  const [local, setLocal] = useState([]);

  useEffect(() => {
    setLocal(inventory.map(i => ({
      id: i.id,
      name: i.name,
      emoji: i.emoji,
      qty: i.qty ?? 1,
      stockMin: i.stockMin ?? null,
    })));
  }, [inventory]);

  const setValue = (id, value) => {
    setLocal(prev =>
      prev.map(p => p.id === id ? { ...p, stockMin: value } : p)
    );
  };

  const saveAll = async () => {
    try {
      for (const item of local) {
        await updateDoc(doc(db, "houses", houseId, "inventory", item.id), {
          stockMin: item.stockMin === "" ? null : Number(item.stockMin),
        });
      }

      toast("✅ Stock minimum sauvegardé");
      onClose();
    } catch (e) {
      console.error(e);
      toast("⚠️ Erreur sauvegarde stock");
    }
  };

  return (
    <div className="moverlay open">
      <div className="modal">

        <div className="mhandle" />
        <div className="mtitle">📦 Stock minimum</div>

        <div className="sinfo green">
          Définis un seuil pour être alerté quand un produit est presque en rupture.
        </div>

        {local.map(item => (
          <div key={item.id} className="stockrow">
            <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:8 }}>
              <span>{item.emoji}</span>
              <strong>{item.name}</strong>
            </div>

            <input
              className="finput"
              type="number"
              min={0}
              placeholder="Ex: 2"
              value={item.stockMin ?? ""}
              onChange={(e) => setValue(item.id, e.target.value)}
            />
          </div>
        ))}

        <button className="bsubmit" onClick={saveAll}>
          Sauvegarder
        </button>

        <button className="bcancel" onClick={onClose}>
          Fermer
        </button>

      </div>
    </div>
  );
}